const crmFinishReasonsIds = ['fraud', 'infringement'];

export { crmFinishReasonsIds };
